import { memo } from 'react';
import classNames from 'classnames';
import ESIInclude from '../../esi';
import styles from './Banner.module.scss';

import { useBannerData } from './data/useBannerData';

export type BannerProps = {
  bannerId: string;
  className: 'banners' | 'readmorebanner-top' | 'readmorebanner-bottom';
};

export const getBannerPath = (className: string) => {
  switch (className) {
    case 'readmorebanner-top':
      return '/';
    case 'readmorebanner-bottom':
      return '/';
    default:
      return `${className}/`;
  }
};

export const Banner = memo(
  ({ bannerId = '', className = 'banners' }: BannerProps) => {
    const { bannerContext } = useBannerData();
    const { [bannerId]: id } = bannerContext;

    if (!bannerId || !id) {
      return null;
    }

    // ESIInclude div ID is id="assembly-content-renderer-{className}-{bannerId}-{id}"
    // e.g. <div id="assembly-content-renderer-banners-brands-all-saints-bnr-1502191-banners" >

    return (
      <aside
        aria-label="Banner"
        data-testid={`${className}-container`}
        className={classNames(styles.container, styles[className])}
      >
        <ESIInclude
          src={`/content-renderer/${getBannerPath(className)}${id}?no-failure=true&includeCoreCss=false&includeCoreJS=false&includePolyfills=false`}
          id={className}
        />
      </aside>
    );
  }
);

Banner.displayName = 'Banner';
